import { useRef } from 'preact/hooks';
import NavigationUtils from '../../../utils/navigation.utils';
import useAndroidBackPress from '../../../hooks/back.listener.hook';
import AppBar from '../../shared/AppBar/AppBar';

export default function TopUpAppBar() {
  const handleCloseClick = () => {
    NavigationUtils.endFlow();
  };
  const handleBackClick = () => {
    NavigationUtils.back();
  };
  const backRef = useRef(null);
  useAndroidBackPress(backRef.current, () => {
    backRef.current.props.onClick();
  });

  return (
    <AppBar
      onCloseClick={handleCloseClick}
      onBackClick={handleBackClick}
      className="fixed-bar"
      backRef={backRef}
    />
  );
}
